import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import "./SantaFloatingButton.css";

export default function SantaFloatingButton() {
  return (
    <Link to="/pere-noel" className="santa-float">
      <span className="santa-float-emoji">🎅</span>
      <div className="santa-float-text">
        <span>Parler</span>
        <span>au Père Noël</span>
      </div>
      <MessageCircle className="santa-float-icon" />
    </Link>
  );
}
